import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent } from 'react';
import { RecurringSeriesContent, RecurringSeriesTotals } from './View/RecurringSeriesContent';
import { useRecurringSeriesView } from './View/useRecurringSeriesView';
import styles from './RecurringSeriesPanel.module.scss';

interface CreatedSeriesViewProps {
    recurringUuid: string;
    onClose: () => void;
}

export const CreatedSeriesView: FunctionComponent<CreatedSeriesViewProps> = props => {
    const series = useRecurringSeriesView(props.recurringUuid);

    return (
        <>
            <div className={styles.header}>
                <h2 className={styles.title}>Recurring Series</h2>
                <button
                    type="button"
                    className={styles.collapseButton}
                    onClick={props.onClose}
                >
                    <FontAwesomeIcon icon={faAngleRight} />
                </button>
                <RecurringSeriesTotals series={series} />
            </div>

            <div className={styles.seriesBody}>
                <RecurringSeriesContent series={series} />
            </div>

            <div className={styles.footer}>
                <Button
                    variant="black"
                    className={styles.submitButton}
                    label="Close"
                    onClick={props.onClose}
                />
            </div>
        </>
    );
};

export default CreatedSeriesView;
